export class t2sManager {

  /* -------------------------
  * T2S RECOMMEND
  ------------------------- */
  static _getRecommendedProducts(options) {
    let pID = options['pID'];

    // XHR data
    let params = {
      "pID": "" + pID + "",
      "cID": "" + _t2sparams.cID + "",
      "tID": (document.cookie.split("t2s-analytics=").length > 1) ? document.cookie.split("t2s-analytics=")[1].split(";")[0] : 'UNKNOWN',
      "cURL": window.location.href
    };

    // Mini-cart -> pID 1600 -> iID = produits dans le panier
    if (pID === "1600") {
      if (_t2sparams.bP) {
        params['iID'] = _t2sparams.bP;
      }
    }

    // Produit -> pID 1200 -> iID = handle du produit sur lequel on est
    if (pID === "1200") {
      params['iID'] = _t2sparams.iID;
    }

    // Collections -> pID 1400 -> iID = handles des produits de la collection affichés sur la page, sans les produits cultes, aID = handle de la collection
    if (pID === "1400") {
      params['aID'] = _t2sparams.aID;
      params['iID'] = _t2sparams.iID;
    }

    // Search avec résultats  -> pID 2000 -> iID = produits issus de la recherche
    if (pID === "2000") {
      params['iID'] = _t2sparams.iID;
    }

    // XHR params
    let settings = {
      "url": "//reco.target2sell.com/1.1/json/Q/" + _t2sparams.cID + "/fr/",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify(params)
    };

    // Ajax Call to T2S
    $.ajax(settings)
      .done(function (response) {
        if (response !== undefined) {
          if (response['blocks'].length > 0) {
            // send recommended products to Klaviyo
            document.dispatchEvent(new CustomEvent('t2s:recommend', {
              bubbles: true,
              detail: {
                blocks: response['blocks']
              }
            }));

            // set T2S recommended products for each space
            for (let i = 0; i < response['blocks'].length; i++) {
              let block = response['blocks'][i];

              // check if response has blocks
              if (block !== undefined) {
                let blockId = block['id'].split(_t2sparams.cID + '-')[1];

                if (options[blockId] !== undefined) {
                  if (block['items'].length > 0) {
                    // get the good option zone from plugin params
                    t2sManager._setRecommendedProducts(block, options[blockId]);

                  } else {
                    //console.error('No T2S items for the block : ' + blockId);
                    t2sManager._displayCurrentProducts(pID, options[blockId]['zoneID'])
                  }
                }
              }
            }
          } else {
            //console.error('No T2S blocks into response');
            t2sManager._displayCurrentProducts(pID)
          }
        } else {
          //console.error('No T2S blocks into response');
          t2sManager._displayCurrentProducts(pID)
        }
      })
      .fail(function () {
        //console.error('T2S request failed');
        t2sManager._displayCurrentProducts(pID)
      });
  }

  static _setRecommendedProducts(block, options) {
    let queryString = [];
    let pID = options['pID'];
    let zoneID = options['zoneID'];
    let overlay = options['overlay'];
    let spaceZone = document.querySelector(options['zoneSelector']);

    // get all recommended handles from T2S response
    for (let i = 0; i < block['items'].length; i++) {
      queryString.push('handle:' + block['items'][i].externalID);
    }


    if (queryString.length > 0) {
      // get search template config
      let requestView = 'recommend-light';

      // get other template for mini-cart
      if (pID === "1600") {
        requestView = 'recommend-mini-cart';
      }

      // get the right template depending on zone
      if (pID === "1200" || zoneID === "1400-8" || pID === "3600" || pID === "2000" || pID === "3400" || overlay === "true") {
        requestView = 'recommend';
      }

      $.ajax({
        url: '/search',
        data: {
          view: requestView,
          type: 'product',
          q: queryString.join(' OR '),
          id: zoneID
        }
      }).then(function (result) {

        if (result !== '') {
          // kill previous slider if needed
          if (spaceZone.classList.contains('slick-initialized')) {
            $(spaceZone).slick('unslick');
          }

          // set T2S products into DOM
          if (zoneID === "1600-18") {
            // mini-cart cross-sell desktop and mobile
            spaceZone = document.querySelectorAll(options['zoneSelector']);
            spaceZone.forEach(function (item, value) {
              item.innerHTML = result;
            })
          } else {
            spaceZone.innerHTML = result;
          }

          // set T2S tracking to products
          t2sManager._setRecommendedProductsTracking(block, options);
          t2sManager._getGtmObject(block, zoneID).then(result => {
            let dataLayer = window.dataLayer || [];

            dataLayer.push({
              'event': 'productImpression',
              'ecommerce': {
                'impressions': result
              }
            });
          });

          // update reco zone
          if (zoneID === "1400-2") {
            let spaceZone = document.querySelector(options['zoneSelector']);
            let spaceZoneArrows = document.querySelector('.collection__cults-custom-arrow-container');
            if (spaceZone) {
              spaceZone.classList.remove('flex-content-desktop');
            }
            if (spaceZoneArrows) {
              if (block.items.length > 4) {
                spaceZoneArrows.classList.remove('hidden-arrow-desk');
              }
            }
          }

          // display arrows for similar products
          if (zoneID === "1200-3") {
            let spaceZone = document.querySelector('#t2s-similar-products');
            let spaceZoneArrows = spaceZone.querySelector('.collection__custom-arrow-container');
            if (spaceZoneArrows) {
              if (block.items.length > 4) {
                spaceZoneArrows.classList.remove('hidden');
              }
            }
          }

          // set slider if needed
          if (options['sliderConfig']) {
            if (options['sliderConfig'] !== 'null') {
              $(spaceZone).slick(options['sliderConfig']);
            } else {
              $(spaceZone).slick();
            }
          }

          // display section when products are available
          if (pID === "2000" || pID === "3400" || pID === "1400" || pID === "3600") {
            if (document.querySelector('#t2S-recommended-products')) {
              document.querySelector('#t2S-recommended-products').classList.remove('hidden');
            }
          }

          if (zoneID === '1200-6') {
            if (document.querySelector('#t2S-recommended-products')) {
              document.querySelector('#t2S-recommended-products').classList.remove('hidden');
            }
          }

          if (zoneID === '1200-3') {
            if (document.querySelector('#t2s-similar-products')) {
              document.querySelector('#t2s-similar-products').classList.remove('hidden');
            }
          }

        } else {
          //console.error('No products known for zone : '+ zoneID);
          spaceZone.classList.remove('t2s-recommend--is-loading');
        }

      });


    } else {
      //console.error('No T2S blocks');
      spaceZone.classList.remove('t2s-recommend--is-loading');
    }
  }

  static _displayCurrentProducts(pid, zoneID) {
    // Hide T2S zones if no products because they don't have fallback products
    if (zoneID !== undefined) {
      if (zoneID === "1200-6") {
        if (document.querySelector('#t2S-recommended-products')) {
          document.querySelector('#t2S-recommended-products').classList.add('hidden');
        }
      }
      if (zoneID === "1200-3") {
        if (document.querySelector('#t2s-similar-products')) {
          document.querySelector('#t2s-similar-products').classList.add('hidden');
        }
      }
    }

    let allZones = document.querySelectorAll('[data-recommend="' + pid + '"]');
    if (allZones) {
      for (let i = 0; i < allZones.length; i++) {
        allZones[i].classList.remove('t2s-recommend--is-loading')
      }
    }
  }

  static _setRecommendedProductsTracking(block, options) {
    let spaceZone = document.querySelector(options['zoneSelector']);
    spaceZone.classList.remove('t2s-recommend--is-loading');

    for (let i = 0; i < block['items'].length; i++) {
      let item = block['items'][i];
      let targetItem = spaceZone.querySelector('[data-t2s-handle="' + item.externalID + '"]');
      if (targetItem) {
        // set T2S tracking to product item
        targetItem.setAttribute('data-t2s-tracking', item.trackingId);

        // set GTM tracking to product item
        if (options['gtmElements'] !== undefined) {

          // Set GTM Custom event to T2S product item
          if (options['gtmElements']['data-custom-event']) {
            let newJSON = JSON.stringify(options['gtmElements']['data-custom-event']);
            newJSON = newJSON
              .replace('product_id', targetItem.getAttribute('data-id'))
              .replace('product_title', targetItem.getAttribute('data-title'))
              .replace('forloop_index', (i + 1));

            targetItem.setAttribute('data-custom-event', newJSON);
          }

          // Set GTM template to T2S product item
          if (options['gtmElements']['data-gtm-list']) {
            if (targetItem.querySelector('[data-action="addToCart"]')) {
              targetItem.querySelector('[data-action="addToCart"]').setAttribute('data-template', options['gtmElements']['data-gtm-list']);
            }
          }
        }
      }
    }
  }

  static async _getGtmObject(block, id) {
    let productHandles = [];

    block.items.forEach((item) => {
      if (item.hasOwnProperty('externalID')) {
        productHandles.push('handle:' + item['externalID']);
      }
    })

    const response = await fetch(`/search?view=product-gtm&type=product&q=${productHandles.join(' OR ')}&id=${id}`, {
      method: 'GET'
    }).catch((error) => {
      // Request failed
      console.error(error);
    });

    if (response.ok) {
      return await response.json();
    }
  }

  /* -------------------------
  * T2S INSPIRE
  ------------------------- */

  static _getInspireData(options) {
    let pID = options['pID'];
    let aID = options['aID'];

    // XHR data
    let params = {
      "pID": "" + pID + "",
      // temp values

      "tID": (document.cookie.split("t2s-analytics=").length > 1) ? document.cookie.split("t2s-analytics=")[1].split(";")[0] : 'UNKNOWN',
      "cURL": window.location.href
    };

    if (_t2sparams.uEM != null) {
      params["uEM"] = _t2sparams.uEM;
    }

    if (_t2sparams.cID != null) {
      params["cID"] = _t2sparams.cID;
    }

    if (aID) {
      params['aID'] = aID;
    }

    let settings = {
      "url": "https://reco.target2sell.com/content/v3/",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify(params)
    };

    // Ajax Call to T2S
    $.ajax(settings)
      .done(function (response) {
        if (response !== undefined) {
          console.log('response', response);
          if (response['spaces'].length > 0) {

            let arrayPush = {};
            // set T2S inspire elements for each spaces
            for (let i = 0; i < response['spaces'].length; i++) {

              let block = response['spaces'][i];
              // check if response has blocks
              if (block !== undefined) {
                // check if element are disable in TS
                let elementDisable = document.querySelector('[data-disable="' + block.id + '"]');
                if (!elementDisable) {
                  if (block.formats[0] !== undefined) {
                    let options = block.formats[0]['campaigns'];
                    arrayPush[block.id] = t2sManager._queryPushManager(options, block.id);
                  } else {
                    t2sManager._removePlaceholders('[data-zone="' + block.id + '"]');
                  }
                }
              }
            }
            // check if element are disable in TS for forced ArrayPush
            let sliderDisable = document.querySelector('[data-disable="1000-115"]');
            if (!sliderDisable) {
              if (arrayPush['1000-119']) {
                //  Add forced slider in ArrayPush
                arrayPush['1000-115'].dataPush.unshift(arrayPush['1000-119'].dataPush[0]);
                //  Remove forced slider
                delete arrayPush['1000-119'];
              }
            }

            t2sManager._dataManager(arrayPush);
          } else {
            //  Remove all the grey on the blocks if T2SInspire is active & spaces are empty
            t2sManager._removePlaceholders('.active_t2s_inspire');
          }
        } else {
          //  Remove all the grey on the blocks if T2SInspire is active & response is empty
          t2sManager._removePlaceholders('.active_t2s_inspire');
        }
      })
  }

  // Construction of the object arrayPush
  static _queryPushManager(options, id) {

    let dataPush = [];

    for (let j = 0; j < options.length; j++) {

      let type = options[j].content.type;
      let items = options[j].content.items;
      let keys = Object.keys(items);
      let queryString = [];

      queryString.push(type);
      queryString.push(j);
      queryString.push('trackingId__' + options[j].trackingId);
      queryString.push('numberBloc__' + (j + 1));
      for (let k = 0; k < keys.length; k++) {
        queryString.push(keys[k] + '__' + items[keys[k]]);
      }

      dataPush[j] = queryString;

    }
    return {
      dataPush: dataPush,
      id: id
    }
  }

  static _dataManager(arrayPush) {

    Object.keys(arrayPush).forEach(function (key) {

      switch (key) {
        case '1400-117':
          t2sManager._collectionT2sPushManager(arrayPush[key]);
          break;

        default:
          t2sManager._hpT2sPushManager(arrayPush[key]);
          break;
      }

    });

  }

  // T2S push in collection pages
  static _collectionT2sPushManager(data) {

    let arrayPush = data['dataPush'];
    Object.keys(arrayPush).forEach(function (key) {

      // initial first push position in product grid
      let countProductList = 6;

      // initial second push position in product grid
      if (arrayPush[key][1] === 1) {
        countProductList = 14;
      }

      // call to alternate template to create push with T2S variables
      $.ajax({
        url: '/search',
        data: {
          view: arrayPush[key][0],
          q: arrayPush[key].join('|')
        }
      }).done(function (result) {

        // find where the push is going to be inserted
        let elementPushPosition = document.querySelector('.product-list__t2s-inspire .product-list__grid-cell_' + countProductList);
        if (elementPushPosition) {
          elementPushPosition.insertAdjacentHTML('afterend', result);
        }

        // insert T2S push in collection grid and remove Shopify old push
        t2sManager._displayT2sBlocks('.bloc-information-' + (arrayPush[key][1] + 1), '[data-zone="' + data['id'] + '"]');
      });

    });

  }

  // Homepage T2S push manager
  static _hpT2sPushManager(data) {

    let queryString = [];
    let type = "";
    let arrayPush = data['dataPush'];
    Object.keys(arrayPush).forEach(function (key) {
      type = arrayPush[key][0];
      Object.keys(arrayPush[key]).forEach(function (keyData) {
        queryString.push(arrayPush[key][keyData]);
      });
      queryString.push('@@');
    });

    // call to alternate template to create push with T2S variables
    $.ajax({
      url: '/search',
      data: {
        view: type,
        q: queryString.join('|')
      }
    }).done(function (result) {
      // find where the push is going to be inserted
      let elementPushPosition = document.querySelector('.' + type);
      if (elementPushPosition) {
        elementPushPosition.insertAdjacentHTML('beforeend', result);
      }

      // check if T2S element is for HP slider
      if (type.indexOf('slide') !== -1) {
        t2sManager._displayT2sSliderHp(data['id']);
      } else {
        t2sManager._displayT2sBlocks('.' + type, '[data-zone="' + data['id'] + '"]');
      }

    });

  }

  // Homepage display T2S slider
  static _displayT2sSliderHp(id) {

    let newT2SSlides = document.querySelectorAll('[data-zone="' + id + '"] .hero__slide-t2s');
    let currentSlider = document.querySelector('[data-zone="' + id + '"].hero__container--slider');

    if (currentSlider) {

      // get number of initial slides count
      let initialSlidesCount = currentSlider.getAttribute('data-count-slider');

      if (newT2SSlides.length > 0) {
        $(currentSlider).slick('refresh');

        // remove initial slides
        for (let i = 0; i < initialSlidesCount; i++) {
          let lastSlider = $(currentSlider).slick("getSlick").slideCount - 1;
          $(currentSlider).slick('slickRemove', lastSlider);
        }
      }

      // Remove the grey on the slider
      currentSlider.classList.remove('active_t2s_inspire');
    }
  }

  // display T2S elements
  static _displayT2sBlocks(t2sElement, placeholder) {
    let elementsToRemove = document.querySelectorAll(t2sElement + '__ts');
    let elementToDisplay = document.querySelectorAll(t2sElement + '__t2s');

    if (elementToDisplay.length > 0) {

      // remove older elements from Shopify
      if (elementsToRemove.length > 0) {
        elementsToRemove.forEach(function (element) {
          element.remove();
        })
      }

      // display new elements from T2S
      elementToDisplay.forEach(function (element) {
        element.classList.remove('hidden');
      })
    }

    // Remove placeholders from collection grid
    t2sManager._removePlaceholders(placeholder);
  }

  // remove placeholders
  static _removePlaceholders(placeholder) {
    let placeholdersToRemove = document.querySelectorAll(placeholder);
    if (placeholdersToRemove.length > 0) {
      placeholdersToRemove.forEach(function (element) {
        element.classList.remove('active_t2s_inspire');
      })
    }
  }

}